/**
 * EB-CRM 공용 리포트 인쇄 모듈 (Premium Clean Report Setup - A4 가로 출력 최적화)
 * @param {string} title - 리포트 대제목
 * @param {Array} headers - 테이블 헤더 제목 배열 (예: ["차량번호", "차대번호"])
 * @param {Array} rows - 데이터 행 2차원 배열
 * @param {Object} metaInfo - 상단에 표기할 필터링 조건 메타 정보 (키-값 쌍)
 */
// 🚀 [보안] 저장된 데이터(고객명 등)에 HTML·스크립트가 섞여 있어도 실행되지 않도록 막는다.
//    인쇄 창은 사이트와 같은 출처라, 이스케이프하지 않으면 악성 문자열이 그대로 실행된다.
export const escapeHtml = (v) => String(v == null ? '' : v)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export const printReport = (title, headers, rows, metaInfo = {}) => {
  // 1. 순수 비어있는 새로운 브라우저 컨텍스트 윈도우 개설
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    return alert("⚠️ 브라우저의 팝업 창 차단이 활성화되어 있습니다.\n팝업을 허용해 주셔야 리포트 출력이 가능합니다.");
  }

  // 2. 메타 정보 컴파일
  const metaHtml = Object.entries(metaInfo)
    .map(([key, val]) => `<span><b>${escapeHtml(key)}:</b> ${escapeHtml(val)}</span>`)
    .join('&nbsp;&nbsp;|&nbsp;&nbsp;');

  // 3. 테이블 헤더 및 로우 엘리먼트 빌드
  const tableHeadersHtml = headers.map(h => `<th>${escapeHtml(h)}</th>`).join('\n');
  const tableRowsHtml = rows.map((row, idx) => {
    const cells = row.map(cell => `<td>${escapeHtml(cell)}</td>`).join('\n');
    return `<tr><td style="text-align: center; color: #64748b; font-weight: 500;">${idx + 1}</td>${cells}</tr>`;
  }).join('\n');

  const now = new Date().toLocaleString();

  // 4. 새 창에 독립적인 리포트 양식 Document 구성 (A4 가로 꽉 찬 화면 대응)
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>${escapeHtml(title)}</title>
      <style>
        /* 🚀 [가로 출력 전면 개편] portrait(세로)에서 landscape(가로) 규격으로 완벽 교정 */
        @page {
          size: A4 landscape; /* 브라우저 인쇄 창이 자동으로 가로 방향을 기본값으로 잡게 만듭니다 */
          margin: 15mm 12mm;  /* 상하 15mm, 좌우 12mm의 황금 여백 비율 유지 */
        }
        
        body {
          font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif;
          margin: 0; 
          color: #0f172a;
          background: white;
          line-height: 1.4;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        
        .report-header {
          text-align: center;
          margin-bottom: 25px; 
          width: 100%;
        }
        
        .report-title {
          font-size: 26px; 
          font-weight: 800;
          color: #0f172a;
          text-align: center;
          margin: 0 0 12px 0;
          letter-spacing: -0.5px;
        }
        
        .report-divider {
          border-top: 3px solid #0f172a;
          margin-bottom: 10px;
          width: 100%;
        }
        
        .report-meta {
          font-size: 12px;
          color: #475569;
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 0 2px;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 5px;
        }
        
        th, td {
          border: 1px solid #94a3b8;
          padding: 9px 11px; 
          font-size: 13px;
          text-align: left;
        }
        
        th {
          background: #f8fafc !important;
          color: #0f172a;
          font-weight: bold;
        }
        
        tr:nth-child(even) {
          background-color: #f8fafc !important;
        }
      </style>
    </head>
    <body>
      <div class="report-header">
        <div class="report-title">${escapeHtml(title)}</div>
        <div class="report-divider"></div>
        <div class="report-meta">
          <div>${metaHtml}</div>
          <div><b>출력 일시:</b> ${now}</div>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th style="width: 50px; text-align: center;">No</th>
            ${tableHeadersHtml}
          </tr>
        </thead>
        <tbody>
          ${tableRowsHtml}
        </tbody>
      </table>
      <script>
        window.onload = function() {
          setTimeout(function() {
            window.print();
            window.close();
          }, 300);
        };
      </script>
    </body>
    </html>
  `);
  printWindow.document.close();
};